import 'regenerator-runtime/runtime';
export { i as default } from './onboard-50f68ab4.js';
import 'bignumber.js';
import 'bnc-sdk';
import 'bowser';